// extracted by mini-css-extract-plugin
module.exports = {"HeaderNavbar__language__flag":"HeaderNavbar_HeaderNavbar__language__flag__gS_tT","fadeInKeyframe":"HeaderNavbar_fadeInKeyframe__hxnqd"};